import { User, TickSquare, Edit, Chat } from "react-iconly";
import Container from "@/components/layout/Container";
import PageTitleBox from "@/components/common/PageTitleBox";
import ServiceSteps from "./ServiceStep";
import ServiceSection from "./ServiceSection";

const ServiceMessaging = () => {
  const steps = [
    {
      number: 1,
      icon: (() => {
        const IconComponent = User as any;
        return <IconComponent set="bulk" size={28} primaryColor="#1976D2" />;
      })(),
      title: "서비스 이용 신청",
      description: "간편 폼 작성을 통한\n기본 정보 등록 및 테스트 계정 발급",
      active: true,
    },
    {
      number: 2,
      icon: (() => {
        const IconComponent = TickSquare as any;
        return <IconComponent set="bulk" size={28} primaryColor="#1976D2" />;
      })(),
      title: "서비스 테스트 진행",
      description: "발급된 테스트 계정으로\nAgent 연동 및 API 테스트 수행",
      active: true,
    },
    {
      number: 3,
      icon: (() => {
        const IconComponent = Edit as any;
        return <IconComponent set="bulk" size={28} primaryColor="#1976D2" />;
      })(),
      title: "온라인 계약 체결",
      description: "추가 서류 제출,\n정식 계약서 작성 및 최종 계약",
      active: true,
    },
  ];

  return (
    <Container>
      <main className="py-[60px]">
        <div className="bg-[linear-gradient(to_bottom,rgb(251,251,251)_11%,#EDF2F9_100%)] rounded-xl pb-32 mb-24">
          {/* Hero Section */}
          <PageTitleBox
            badge="메시징 서비스 도입"
            badgeColor="navy"
            title={
              <>
                테스트 신청부터 본 계약까지
                <br />
                <span className="text-[#4361ee]">온라인</span>에서 한 번에 완료하세요
              </>
            }
            subtitle="번거로운 계약 과정이 사라지고 메시징 서비스 도입이 더 빨라집니다."
            showSeparator={false}
          />

          {/* Steps */}
          <ServiceSteps steps={steps} titleColor="text-[#1a1a1a]" iconBackground="bg-[#E3F2FD]" />
        </div>

        {/* Section 1: 서비스 이용 신청 */}
        <ServiceSection
          badge="서비스 이용 신청"
          title="웹 신청으로 즉시 테스트하고, 정식 계약까지 간편하게"
          icon={<User set="bulk" size={36} primaryColor="#ff9800" />}
          iconBgColor="bg-white"
          buttonText="서비스 이용 신청하기"
          buttonLink="/service/submit?type=messaging"
          bgColor="bg-[#F9F7ED]"
          description={
            <>
              <p className="text-[1.55rem] text-[#333333] leading-relaxed">
                <strong className="font-semibold">
                  신청 폼 작성을 완료하시면 담당자 확인 후 연락
                </strong>
                을 드립니다.
              </p>
              <p className="text-[1.55rem] text-[#333333] mb-3 leading-relaxed">
                이후 정식 계약 체결을 위해 필요한 서류를 주고받는 절차가 진행될 예정입니다.
              </p>
              <p className="text-[1.35rem] text-[#4361ee] font-medium">
                서비스 신청 후 승인까지 영업일 기준 최대 1~2일이 소요될 수 있습니다.
              </p>
            </>
          }
        />

        {/* Section 2: 서비스 테스트 진행 */}
        <ServiceSection
          badge="서비스 테스트 진행"
          title="먼저 써보고 결정하는 실패 없는 서비스 도입"
          icon={<Chat set="bulk" size={36} primaryColor="#2196f3" />}
          iconBgColor="bg-white"
          buttonText="Agent & API 명세 다운받기"
          buttonLink="/service/test"
          bgColor="bg-[#F0F9ED]"
          description={
            <>
              <p className="text-[1.55rem] text-[#333333] leading-relaxed">
                <strong className="font-semibold">발급된 테스트 계정을 연결</strong>하여,
              </p>
              <p className="text-[1.55rem] text-[#333333] mb-3 leading-relaxed">
                고객님의 시스템에서 메시지 발송 성능을 직접 확인해보세요.
              </p>
              <p className="text-[1.35rem] text-[#4361ee] font-medium">
                직접 써보고 도입을 결정할 수 있어 실패 부담이 없습니다.
              </p>
            </>
          }
        />
        <p className="text-[1.2rem] text-right text-red-500 mt-5">
          메시지 발송 성능 테스트는 전용 테스트 계정 발급 후 이용 가능합니다.
        </p>
      </main>
    </Container>
  );
};

export default ServiceMessaging;
